import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Reveal } from '../ui/Reveal';
export function MoreServices() {
  const {
    t
  } = useLanguage();
  return <section id="servicios" className="border-t border-black/[0.06] bg-white py-20 md:py-24" data-id="element-181" data-mp="31yjbwujmlk14">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 md:grid-cols-[1fr_2fr] md:gap-16 md:px-6" data-id="element-182" data-mp="2wzg7ncbgzhu7">
        <Reveal data-id="element-183" data-mp="2s0by2kkmvi3c">
          <h2 className="text-2xl font-semibold tracking-[-0.02em] text-graphite md:text-3xl" data-id="element-184" data-mp="2s0v6naoe8u4p">
            {t.services.title}
          </h2>
        </Reveal>
        <div className="grid gap-8 sm:grid-cols-2 sm:gap-10" data-id="element-185" data-mp="2n3d6o9sctp8u">
          {t.services.items.map((item, i) => <Reveal key={item.title} delay={i * 0.06} data-id="element-186" data-mp="2j1i6j8m5thwn" data-mpi={i}>
              <div className="border-t border-black/10 pt-5" data-id="element-187" data-mp="2e1vtp0a8u3od">
                <h3 className="text-base font-semibold text-graphite" data-id="element-188" data-mp="h80nz9whqwn4">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-subtle" data-id="element-189" data-mp="c97m6eqkgu2s">{item.desc}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}